import type { Translate } from 'next-translate';
import type { FiltersReportType } from 'src/utils/hooks/swr/reports/useFetchReports.tsx';

export type ReportTypeOptionType = {
    value: undefined | FiltersReportType;
    label: string;
    type?: 'frequency';
};

export const reportTypesOptions = (t: Translate): ReportTypeOptionType[] => [
    { value: undefined, label: t('reports:general.all_reports') },
    { value: 'yearly', label: t('reports:general.every_year'), type: 'frequency' },
    { value: 'monthly', label: t('reports:general.every_month'), type: 'frequency' },
    { value: 'weekly', label: t('reports:general.every_week'), type: 'frequency' },
    { value: 'daily', label: t('reports:general.every_day'), type: 'frequency' },
    { value: 'quarterly', label: t('reports:general.every_quarter'), type: 'frequency' },
    { value: 'hashtags', label: t('reports:general.hashtag_exports') },
    { value: 'competitors', label: t('reports:general.competitors_exports') },
    { value: 'dashboards', label: t('reports:general.dashboard_export') },
    { value: 'accounts', label: t('reports:general.account_export') }
];

export const showOptions = (t: Translate) =>
    [
        { value: '5', label: `${t('reports:general.show')} 5` },
        { value: '10', label: `${t('reports:general.show')} 10` },
        { value: '20', label: `${t('reports:general.show')} 20` }
    ] as const;
